import React, { useEffect, useState } from 'react'
import { Formik, Form } from 'formik'
import AccountLinkAccountSelectSearchField from 'domains/account-link/molecules/account-select-search-field'
import AccountLinkAccountOptions from 'domains/account-link/organisms/account-options'
import {  Button } from 'reactstrap'
import IdentitiesApi from 'api/v2/admins/identities-api'
import * as Yup from 'yup'
import PropTypes from 'prop-types'
import { ALERT_TYPES } from 'constants/alert-constants'
import { useLocation } from 'react-router'

const propTypes = {
  pageUtils: PropTypes.shape({
    setAlertMsg    : PropTypes.func,
    setApiErrorMsg : PropTypes.func
  })
}

const accountLinkSchema = Yup.object().shape({
  seller: Yup.object().when('selected_account', {
    is   : (selected_account) => selected_account === 'seller',
    then : Yup.object().required('Required')
  }),
  customer: Yup.object().when('selected_account', {
    is   : (selected_account) => selected_account === 'customer',
    then : Yup.object().required('Required')
  }),
  selected_account: Yup.string().required('Required')
})

const AccountLinkPage = ({ pageUtils }) => {

  const location = useLocation()
  const filters  = Object.fromEntries(new URLSearchParams(location.search))

  const [ initialSeller, setInitialSeller ]     = useState(undefined)
  const [ initialCustomer, setInitialCustomer ] = useState(undefined)


  useEffect(() => {
    const sellerEmail = filters.sellerEmail
    if (sellerEmail) {
      getInitialAccountData(sellerEmail)
      return
    }

    const customerEmail = filters.customerEmail
    if (customerEmail) {
      getInitialAccountData(customerEmail)
      return
    }
  }, [ location.search ]) // eslint-disable-line react-hooks/exhaustive-deps

  const getInitialAccountData = (email) => {
    IdentitiesApi.getSellerProfile(email)
      .then((response) => {
        const seller = response.data.seller
        if (seller) {
          setInitialSeller(seller)
        }
      })
      .catch((error) => {
        pageUtils.setApiErrorMsg(error.response.data)
      })

    IdentitiesApi.getCustomerProfile(email)
      .then((response) => {
        const customer = response.data.customer
        if (customer) {
          setInitialCustomer(customer)
        }
      })
      .catch((error) => {
        pageUtils.setApiErrorMsg(error.response.data)
      })
  }

  const handleSubmitForm = async (values, formikBag) => {

    await IdentitiesApi.accountLink(values)
      .then(() => {
        let msg = 'Account Link Success'

        pageUtils.setAlertMsg(msg, ALERT_TYPES.SUCCESS)
        formikBag.resetForm()
      })
      .catch((error) => {
        pageUtils.setApiErrorMsg(error.response.data)
        formikBag.setErrors(error.response.data.messages)
      })
  }

  const customerFieldOptionLabel = (option) => (
    <span className='mr-3'>{ option.email }</span>
  )

  const sellerFieldOptionLabel = (option) => (
    <>
      <span className='mr-3'>{ option.email }</span>
    </>
  )

  const handleSelectedAccountChange = (name,value,setFieldValue) => {
    setFieldValue(name, value)
  }

  return (
    <Formik
      enableReinitalize={ false }
      initialValues={{
        customer         : initialCustomer || '',
        seller           : initialSeller || '',
        selected_account : ''
      }}
      enableReinitialize={ true }
      onSubmit={ handleSubmitForm }
      validationSchema={ accountLinkSchema }
    >
      {
        ({ values, setFieldValue, isSubmitting, errors }) => {
          const userAccounts = [
            {
              ...values.customer,
              type: 'customer'
            },
            {
              ...values.seller,
              type: 'seller'
            }
          ]

          return (
            <Form>
              <AccountLinkAccountSelectSearchField
                name='customer'
                label='customer'
                required={ true }
                placeholder="Search with Customer email or mobile"
                apiRequest={ IdentitiesApi.getCustomer }
                responseKey="customers"
                optionLabel={ customerFieldOptionLabel }
              />
              <AccountLinkAccountSelectSearchField
                name='seller'
                label='seller'
                required={ true }
                placeholder="Search with Seller email or mobile"
                apiRequest={ IdentitiesApi.getSeller }
                responseKey="sellers"
                optionLabel={ sellerFieldOptionLabel }
              />

              <AccountLinkAccountOptions
                accounts={ userAccounts }
                setFieldValue={ setFieldValue }
                handleChange={ handleSelectedAccountChange }
                selectedValue={ values.selected_account }
                errorMessage={ errors.selected_account }
              />

              <Button
                block
                color='primary'
                type='submit'
                disabled={ isSubmitting }
              >
                  Submit
              </Button>
            </Form>
          )
        }
      }
    </Formik>
  )
}

AccountLinkPage.propTypes = propTypes

export default AccountLinkPage